import { GraduationCap, Landmark, School } from "lucide-react";
import { AUDIENCE_ITEMS } from "./marketing-content";

const ICONS = [GraduationCap, Landmark, School] as const;

export function MarketingAudiences() {
  return (
    <section id="who" className="container mx-auto px-4 py-20">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Built for real libraries</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Whether you run a campus, a public system, or a school library, PhiloLMS fits your
          operations without a heavy IT project.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {AUDIENCE_ITEMS.map((item, index) => {
          const Icon = ICONS[index];
          return (
            <div key={item.title} className="p-6 rounded-lg border bg-card">
              <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-muted-foreground">{item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
